import {styled} from '@mui/system'
import Editor, {JSONEditorMode, JSONEditorOptions} from 'jsoneditor'
import 'jsoneditor/dist/jsoneditor.min.css'
import * as React from 'react'
import {useEffect, useRef} from 'react'

interface Props {
  onChange: (json: any) => void
  json: any
  readOnly?: boolean
}

const Container = styled('div')({
  height: '70vh',
})

export const JSONEditor: React.FC<Props> = ({json, onChange, readOnly}) => {
  const jsonRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    let jsonEditor: Editor | null = null
    if (jsonRef.current) {
      const commonOptions = {
        onChange: () => {
          if (readOnly || !jsonEditor) return
          try {
            const changedJson = jsonEditor.get()
            onChange(changedJson)
          } catch (e) {
            console.error('Error getting JSON from editor:', e)
          }
        },
        history: !readOnly,
        onEditable: readOnly ? () => false : undefined,
      }

      let modeSpecificOptions: Partial<JSONEditorOptions>

      if (readOnly) {
        modeSpecificOptions = {
          mode: 'code' as JSONEditorMode,
          modes: ['code' as JSONEditorMode, 'tree' as JSONEditorMode],
        }
      } else {
        modeSpecificOptions = {
          mode: 'code' as JSONEditorMode,
          modes: ['code' as JSONEditorMode, 'tree' as JSONEditorMode],
        }
      }

      const editorOptions: JSONEditorOptions = {
        ...commonOptions,
        ...modeSpecificOptions,
        onModeChange: (newMode: JSONEditorMode, _oldMode: JSONEditorMode) => {
          if (jsonEditor && newMode === 'code' && jsonEditor.aceEditor) {
            jsonEditor.aceEditor.setReadOnly(!!readOnly)
          }
        },
      }

      jsonEditor = new Editor(jsonRef.current, editorOptions, json)

      if (readOnly && jsonEditor.getMode() === 'code' && jsonEditor.aceEditor) {
        jsonEditor.aceEditor.setReadOnly(true)
      }
    }
    return () => jsonEditor?.destroy()
  }, [json, onChange, readOnly])

  return <Container id="react-json-editor-wrapper" ref={jsonRef} />
}
